import React, { useState } from 'react'
import { FiPlusCircle, FiXCircle } from 'react-icons/fi'

import FormContatos from '../../../components/FormContatos'
import Spinner from '../../../components/Spinner'
import Table from '../../../components/Table'

import { api, authHeaders } from '../../../services/api'

import { Container } from './styles'

export default function ({ pessoa, reload, editable = true, className = '' }) {
    const [showForm, setShowForm] = useState(false)
    const [initialValues, setInitialValues] = useState(null)
    const [editId, setEditId] = useState(null)

    async function handlePrepareEdit(id) {
        setEditId(id)

        const { contato, tipo_contato } = pessoa?.contato.find(c => c.id === id) || []

        setInitialValues({
            tipo_contato: { value: tipo_contato.id, label: tipo_contato.descricao },
            valor_contato: contato
        })

        setShowForm(true)
    }

    async function handleDelete(id) {
        try {
            await api.delete(`contato/${id}`, authHeaders())

            reload()
        } catch (e) {
            return false
        }

        return true
    }

    return (
        <Container className={`animated fadeInUp delay-700ms bg-white text-slate-800 ${className}`}>
            <h1 className="text-slate-800">Contatos</h1>

            {editable ? (
                <>
                    {showForm ? (
                        <div 
                            className="flex items-center gap-1.5 cursor-pointer hover:opacity-80 w-fit hover:bg-slate-100 rounded-md px-4 py-2 justify-self-end"
                            onClick={() => {
                                setShowForm(false)
                                setInitialValues(null)
                                setEditId(null)
                            }}
                            style={{ gridArea: 'icon' }}
                        >
                            <FiXCircle
                                size={20}
                                color="#1e293b"
                            />

                            <span className="text-center text-xs">Fechar</span>
                        </div>
                    ) : (
                        <div 
                            className="flex items-center gap-1.5 cursor-pointer hover:opacity-80 w-fit hover:bg-slate-100 rounded-md px-4 py-2 justify-self-end"
                            onClick={() => {
                                setShowForm(true)
                            }}
                            style={{ gridArea: 'icon' }}
                        >
                            <FiPlusCircle
                                size={20}
                                color="#1e293b"
                            />

                            <span className="text-center text-xs">Adicionar</span>
                        </div>
                    )}
                </>
            ) : (
                <div />
            )}

            {showForm && (
                <FormContatos
                    contatoInitialValues={initialValues}
                    editId={editId}
                    pessoa={pessoa}
                    style={{ gridArea: 'form' }}
                    className="animated fadeIn"
                    reload={() => {
                        reload()
                        setShowForm(false)
                        setInitialValues(null)
                        setEditId(null)
                    }}
                />
            )}

            {pessoa ? (
                <Table
                    headers={[
                        { name: 'contato', value: 'Contato' },
                        {
                            name: 'icone', value: 'Tipo', icon: true, style: { width: 80 }
                        }
                    ]}
                    data={pessoa?.contato || []}
                    handlePrepareEdit={editable && handlePrepareEdit}
                    handleDelete={editable && handleDelete}
                    confirmExclusion={{
                        attr: 'contato',
                        template: 'Deseja realmente excluir o contato #attr#?'
                    }}
                    emptyLabel="Nenhum contato adicionado"
                />
            ) : (
                <Spinner />
            )}
        </Container>
    )
}
